import React from "react";

export default function PrivacyPolicy({ onBack }) {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>{"< 뒤로"}</button>
      </div>

      <div style={styles.content}>
        <h1 style={styles.title}>개인정보처리방침</h1>
        <p style={styles.intro}>
          크루픽(이하 "서비스")은 이용자의 개인정보를 중요시하며, 개인정보 보호법 등 관련 법령을 준수합니다.
        </p>

        <Section title="1. 수집하는 개인정보 항목">
          <ul style={styles.list}>
            <li>Google 로그인 정보 (이메일, 프로필 사진, 이름)</li>
            <li>닉네임, 성별, 프로필 정보</li>
            <li>팀 정보 (종목, 지역, 레벨 등)</li>
            <li>채팅 메시지 내용</li>
            <li>서비스 이용 기록</li>
          </ul>
        </Section>

        <Section title="2. 개인정보 수집 목적">
          <ul style={styles.list}>
            <li>회원 식별 및 서비스 제공</li>
            <li>팀 매칭 서비스 운영</li>
            <li>채팅 서비스 제공</li>
          </ul>
        </Section>

        <Section title="3. 개인정보 보유 및 이용 기간">
          <ul style={styles.list}>
            <li>회원 탈퇴 시 즉시 삭제</li>
            <li>관련 법령에 따른 보존 기간 준수</li>
          </ul>
        </Section>

        <Section title="4. 개인정보 제3자 제공">
          <p style={styles.text}>
            크루픽은 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다.
            다만, 법령에 의한 요청이 있는 경우에는 예외로 합니다.
          </p>
        </Section>

        <Section title="5. 개인정보 처리 위탁">
          <ul style={styles.list}>
            <li><strong>Google</strong> — 소셜 로그인 인증</li>
            <li><strong>Supabase</strong> — 데이터베이스 저장 및 관리</li>
            <li><strong>Vercel</strong> — 서비스 호스팅 및 배포</li>
          </ul>
        </Section>

        <Section title="6. 이용자 권리">
          <ul style={styles.list}>
            <li>개인정보 열람, 수정, 삭제 요청 가능</li>
            <li>언제든지 회원 탈퇴를 통해 개인정보 삭제 가능</li>
          </ul>
        </Section>

        <Section title="7. 개인정보 보호책임자">
          <p style={styles.text}>
            이메일: <a href="mailto:gangsada@naver.com" style={styles.link}>gangsada@naver.com</a>
          </p>
        </Section>

        <div style={styles.footer}>
          <p style={styles.footerText}>본 개인정보처리방침은 2026년 3월 29일부터 시행됩니다.</p>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={styles.section}>
      <h2 style={styles.sectionTitle}>{title}</h2>
      {children}
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    background: "#f7f8fa",
    fontFamily: "'Noto Sans KR', sans-serif",
    maxWidth: 430,
    margin: "0 auto",
    overflow: "hidden",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  header: {
    position: "sticky",
    top: 0,
    background: "#fff",
    borderBottom: "1px solid #e5e7eb",
    padding: "calc(env(safe-area-inset-top) + 14px) 16px 14px",
    zIndex: 10,
  },
  backBtn: {
    background: "none",
    border: "none",
    fontSize: 15,
    fontWeight: 600,
    color: "#E24B4A",
    cursor: "pointer",
    padding: 0,
  },
  content: {
    padding: "20px 20px 40px",
    boxSizing: "border-box",
  },
  title: {
    fontSize: 22,
    fontWeight: 800,
    color: "#111827",
    margin: "0 0 8px",
  },
  intro: {
    fontSize: 13,
    color: "#6b7280",
    lineHeight: 1.7,
    margin: "0 0 24px",
  },
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: 700,
    color: "#111827",
    margin: "0 0 8px",
    paddingBottom: 6,
    borderBottom: "2px solid #E24B4A",
    display: "inline-block",
  },
  list: {
    margin: "0",
    paddingLeft: 20,
    fontSize: 13,
    color: "#374151",
    lineHeight: 2,
  },
  text: {
    margin: 0,
    fontSize: 13,
    color: "#374151",
    lineHeight: 1.8,
  },
  link: {
    color: "#E24B4A",
    textDecoration: "none",
    fontWeight: 600,
  },
  footer: {
    marginTop: 32,
    paddingTop: 16,
    borderTop: "1px solid #e5e7eb",
  },
  footerText: {
    fontSize: 12,
    color: "#9ca3af",
    margin: 0,
  },
};
